/**
 * Desktop nav sidebar: verplaatst de echte megamenu-inhoud (incl. plaatjes)
 * naar de linkerzijbalk. Bij sluiten opnieuw teruggezet.
 */
(function () {
  var MQ = window.matchMedia('(min-width: 992px)');
  var root = null;
  var navEl = null;
  var titleEl = null;
  var hintEl = null;
  var viewAllEl = null;
  var open = false;
  var lastFocus = null;
  var parked = null; // { el, parent, next }

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function isDesktop() {
    return MQ.matches;
  }

  function topItems() {
    return qsa('.header .menu_bar .menu > ul > li');
  }

  function itemLabel(li) {
    var a = li.querySelector(':scope > a');
    return a ? (a.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function itemKey(li) {
    return (itemLabel(li) || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
  }

  function submenuOf(li) {
    return li.querySelector(':scope > ul');
  }

  function findItemByKey(key) {
    var found = null;
    topItems().forEach(function (li) {
      if (!found && itemKey(li) === key) found = li;
    });
    return found;
  }

  function restoreParked() {
    if (!parked || !parked.el || !parked.parent) {
      parked = null;
      return;
    }
    parked.el.classList.remove('uf-nav-sidebar__hosted');
    parked.el.style.cssText = '';
    if (parked.next && parked.next.parentNode === parked.parent) {
      parked.parent.insertBefore(parked.el, parked.next);
    } else {
      parked.parent.appendChild(parked.el);
    }
    parked = null;
  }

  function parkSubmenu(sub) {
    restoreParked();
    if (!sub || !navEl) return;
    parked = {
      el: sub,
      parent: sub.parentNode,
      next: sub.nextSibling,
    };
    sub.classList.add('uf-nav-sidebar__hosted');
    // Force visible inside sidebar (overrides mega-hide rules)
    sub.style.display = 'block';
    sub.style.visibility = 'visible';
    sub.style.pointerEvents = 'auto';
    sub.style.position = 'static';
    sub.style.opacity = '1';
    sub.style.width = 'max-content';
    sub.style.maxWidth = 'none';
    sub.style.left = 'auto';
    sub.style.right = 'auto';
    sub.style.top = 'auto';
    sub.style.transform = 'none';
    navEl.appendChild(sub);

    // Lazy images: promote data-src if needed
    qsa('img', sub).forEach(function (img) {
      if (!img.getAttribute('src') && img.getAttribute('data-src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
      }
      if (img.getAttribute('loading') === 'lazy') {
        // already in view in sidebar
        img.removeAttribute('loading');
      }
    });
  }

  function updateTop() {
    var mb = qs('.row.menu_bar');
    var hdr = qs('header.header');
    var el = mb || hdr;
    var top = 0;
    if (el) top = Math.max(0, Math.round(el.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--uf-nav-sidebar-top', top + 'px');
  }

  function listsInSidebar() {
    var lists = qsa('.uf-nav-cols__list, ul.normal-sub-sub', root);
    qsa('ul.uf-nav-sidebar__hosted', root).forEach(function (ul) {
      if (!ul.querySelector('.uf-nav-cols, .uf-nav-cols__list')) lists.push(ul);
    });
    return lists;
  }

  function chromeBeside(ul) {
    var col = ul.closest('.uf-nav-cols__col');
    if (!col) return 8;
    var h = 0;
    Array.prototype.forEach.call(col.children, function (child) {
      if (child === ul) return;
      if (child.contains(ul)) {
        Array.prototype.forEach.call(child.children, function (inner) {
          if (inner !== ul && !inner.contains(ul)) h += inner.offsetHeight + 6;
        });
      } else {
        h += child.offsetHeight + 10;
      }
    });
    return h;
  }

  function fitSidebarColumns() {
    if (!open || !root) return;
    var body = qs('[data-uf-nav-sidebar-body]', root);
    var panel = qs('.uf-nav-sidebar__panel', root);
    if (!body || !panel) return;
    panel.style.width = '';

    var bodyStyle = window.getComputedStyle(body);
    var padY = (parseFloat(bodyStyle.paddingTop) || 0) + (parseFloat(bodyStyle.paddingBottom) || 0);
    var available = body.clientHeight - padY;
    if (available < 80) return;

    var lists = listsInSidebar();
    lists.forEach(function (ul) {
      ul.classList.remove('is-flow');
      ul.style.height = '';
      ul.style.width = '';
      ul.style.columnWidth = '';
      ul.style.removeProperty('--uf-ns-list-h');
    });

    lists.forEach(function (ul) {
      if (!ul.children.length) return;
      /* PVC 4-koloms menu: vaste PLAK|CLICK|KLEUR|MERK — niet horizontaal laten doorstromen */
      if (ul.closest('.uf-nav-cols__grid--pvc-4col')) return;
      if (
        ul.classList.contains('uf-nav-cols__list--kleur') ||
        ul.classList.contains('uf-nav-cols__list--ral')
      ) {
        return;
      }
      var maxH = Math.max(180, available - chromeBeside(ul) - 4);
      if (ul.scrollHeight <= maxH + 8) return;
      ul.style.setProperty('--uf-ns-list-h', maxH + 'px');
      ul.classList.add('is-flow');
    });
  }

  function scheduleFit() {
    window.requestAnimationFrame(function () {
      fitSidebarColumns();
    });
  }

  function setOpen(next, focusKey) {
    if (!root || !isDesktop()) return;
    updateTop();
    open = !!next;
    root.classList.toggle('is-open', open);
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('uf-nav-sidebar-open', open);
    document.body.classList.toggle('uf-nav-sidebar-open', open);

    if (open) {
      lastFocus = document.activeElement;
      buildNav(focusKey || null);
      scheduleFit();
      window.setTimeout(scheduleFit, 80);
      var closeBtn = qs('[data-uf-nav-sidebar-close]', root);
      if (closeBtn) closeBtn.focus();
    } else {
      restoreParked();
      if (navEl) navEl.innerHTML = '';
      var panel = qs('.uf-nav-sidebar__panel', root);
      if (panel) panel.style.width = '';
      setHeadViewAll(null);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try {
          lastFocus.focus();
        } catch (e) {
          /* ignore */
        }
      }
    }
  }

  function setHeadViewAll(href) {
    if (!viewAllEl) return;
    if (href && href !== '#' && href !== 'javascript:void(0);' && href.indexOf('javascript:') !== 0) {
      viewAllEl.href = href;
      viewAllEl.hidden = false;
    } else {
      viewAllEl.removeAttribute('href');
      viewAllEl.hidden = true;
    }
  }

  function buildNav(focusKey) {
    if (!navEl) return;
    restoreParked();
    navEl.innerHTML = '';

    if (focusKey) {
      var li = findItemByKey(focusKey);
      if (!li) {
        topItems().some(function (item) {
          if (submenuOf(item)) {
            li = item;
            focusKey = itemKey(item);
            return true;
          }
          return false;
        });
      }
      if (!li) return;

      var label = itemLabel(li);
      if (titleEl) titleEl.textContent = label || 'Menu';
      if (hintEl) hintEl.hidden = true;

      var a = li.querySelector(':scope > a');
      var href = a ? a.getAttribute('href') || '#' : '#';
      setHeadViewAll(href);

      var wrap = document.createElement('div');
      wrap.className = 'uf-nav-sidebar__single';
      navEl.appendChild(wrap);

      var host = document.createElement('div');
      host.className = 'uf-nav-sidebar__host';
      wrap.appendChild(host);
      // temporarily set navEl target for park
      var prevNav = navEl;
      navEl = host;
      var sub = submenuOf(li);
      if (sub) parkSubmenu(sub);
      else {
        var empty = document.createElement('p');
        empty.className = 'uf-nav-sidebar__empty';
        empty.textContent = 'Geen submenu.';
        host.appendChild(empty);
      }
      navEl = prevNav;
      return;
    }

    if (titleEl) titleEl.textContent = 'Menu';
    setHeadViewAll(null);
    if (hintEl) {
      hintEl.hidden = false;
      hintEl.textContent = 'Kies een categorie:';
    }

    var list = document.createElement('ul');
    list.className = 'uf-nav-sidebar__cat-list';
    topItems().forEach(function (li, idx) {
      var label = itemLabel(li);
      if (!label || !submenuOf(li)) return;
      var key = itemKey(li) || 'item-' + idx;
      var item = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'uf-nav-sidebar__cat-btn';
      btn.textContent = label;
      btn.addEventListener('click', function () {
        buildNav(key);
      });
      item.appendChild(btn);
      list.appendChild(item);
    });
    navEl.appendChild(list);
  }

  function onTopClick(e) {
    if (!isDesktop()) return;
    var a = e.target.closest('.header .menu_bar .menu > ul > li > a');
    if (!a) return;
    var li = a.closest('li');
    if (!li || !submenuOf(li)) return;
    e.preventDefault();
    e.stopPropagation();
    setOpen(true, itemKey(li));
  }

  function onTriggerClick(e) {
    if (!isDesktop()) return;
    var t = e.target.closest('.uf-header-menu-trigger, .menu-btn a[href="#menu"]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    if (open) setOpen(false);
    else setOpen(true, null);
  }

  function onKey(e) {
    if (e.key === 'Escape' && open) setOpen(false);
  }

  function onMq() {
    if (!isDesktop() && open) setOpen(false);
    document.documentElement.classList.toggle('uf-nav-sidebar-mode', isDesktop());
  }

  function init() {
    root = qs('#ufNavSidebar');
    if (!root) return;
    navEl = qs('[data-uf-nav-sidebar-nav]', root);
    titleEl = qs('#uf-nav-sidebar-title', root);
    hintEl = qs('.uf-nav-sidebar__hint', root);
    viewAllEl = qs('[data-uf-nav-sidebar-view-all]', root);

    document.documentElement.classList.add('uf-nav-sidebar-mode');
    onMq();
    updateTop();
    window.addEventListener('resize', function () {
      updateTop();
      scheduleFit();
    });
    window.addEventListener('scroll', updateTop, { passive: true });
    document.addEventListener('uf-nav-dyn-ready', scheduleFit);
    if (navEl && typeof MutationObserver !== 'undefined') {
      var fitObserver = new MutationObserver(function () {
        if (open) scheduleFit();
      });
      fitObserver.observe(navEl, { childList: true, subtree: true });
    }

    var hdr = qs('header.header');
    if (hdr && typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        updateTop();
      });
      ro.observe(hdr);
    }

    document.addEventListener('click', onTopClick, true);
    document.addEventListener('click', onTriggerClick, true);
    document.addEventListener('keydown', onKey);
    qsa('[data-uf-nav-sidebar-close]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(false);
      });
    });

    if (typeof MQ.addEventListener === 'function') MQ.addEventListener('change', onMq);
    else if (typeof MQ.addListener === 'function') MQ.addListener(onMq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
